export const getRealTimeHeaders = (isRealTime: boolean) => ({
  'Content-Type': 'application/json',
  'X-Real-Time-Cache-Disable': isRealTime,
});
